import type { ContactSuggestionModel } from '@src/service/model/contact/ContactSuggestionModel'

import Repository from './base'

export const CONTACT_SUGGESTION_TABLE_NAME = 'contactSuggestion'
export class ContactSuggestionRepository extends Repository<ContactSuggestionModel> {}
